module.exports = "/365FarmNet/dist/dashboard-selector.1d7d779bceb795429fe90f20f09fc4ae.html";